module.exports = __webpack_public_path__ + "uploadPortfolios.bd46631c59a4e6e53b68b6c5293d51ab.png";